import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Checkbox,
  Typography,
  Tab,
  AppBar,
  Tabs,
  TablePagination,
  Paper,
  Button,
  Table,
  TableFooter,
  TableRow,
} from "@material-ui/core";
import { withSnackbar } from "notistack";

import PropTypes from "prop-types";

//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  Diurnos: "hotPointsDiurno",
  Nocturnos: "hotPointsNocturno",
};

//Componente para los tabs

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

//Propiedades de los tabs
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

//Componente Puntos de Calor
class HotSpots extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      hotPointsD: false,
      hotPointsN: false,
      hotPointsDData: [],
      hotPointsNData: [],
      loadedDPoints: false,
      loadedNPoints: false,
      loadingDPoints: false,
      loadingNPoints: false,
      tabIndex: 0,
      pageD: 0,
      rowsPerPageD: 10,
      pageN: 0,
      rowsPerPageN: 10,
      createdRender: false,
    };
  }

  //Establece el estado del componente en caso de error en la llamada del servicio
  getDummyPointData = (tipo) => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });
    let stateName = `hotPoints${tipo}Data`;
    let loading = `loading${tipo}Points`;
    this.setState({
      [stateName]: [],
      [loading]: false,
    });
  };

  //Abre nueva ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Obtiene los puntos del serivicio de Puntos de Calor
  getPuntos = async (tipo) => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.Diurnos
    );
    var serviceUrl = `${proxieURL}${layer.url}`;
    let loading = `loading${tipo}Points`;
    this.setState({ [loading]: true });
    const res = await fetch(serviceUrl, {
      method: "GET",
      timeout: 8000,
    }).catch((err) => {
      this.getDummyPointData(tipo);
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.json();
        let stateName = `hotPoints${tipo}Data`;
        let loaded = `loaded${tipo}Points`;

        let layerName =
          tipo === "D" ? layerNames.Diurnos : layerNames.Nocturnos;

        if (tipo === "D") {
          data.features = data.features.filter(
            (p) => new Date(p.properties.fecha).getUTCHours() < 18
          );
        } else {
          data.features = data.features.filter(
            (p) => new Date(p.properties.fecha).getUTCHours() >= 18
          );
        }
        this.setState(
          {
            [stateName]: data,
            [loaded]: true,
          },
          () => {
            this.drawHotPoints(layerName, data, tipo);
          }
        );
      } else {
        this.getDummyPointData(tipo);
      }
    }
  };

  //Renderea lospuntos en el mapa del servicio de Puntos de Calor
  drawHotPoints = (layerId, data, t) => {
    const { esri } = this.props;
    let features = [];
    let pointsInside = {
      pc: [],
      tipo: "",
      total: 0,
    };
    // let cdmxExtent = new esri.Extent({
    //   xmax: -98.409,
    //   xmin: -99.889,
    //   ymax: 19.649,
    //   ymin: 18.894,
    //   spatialReference: new esri.SpatialReference(4326),
    // });
    let tipo = t === "D" ? "Diurno" : "Nocturno";
    pointsInside["tipo"] = tipo;

    data.features.forEach((hotPoint) => {
      let latitude = hotPoint.geometry.coordinates[0];
      let longitude = hotPoint.geometry.coordinates[1];

      let point = new esri.Point(
        longitude,
        latitude,
        new esri.SpatialReference({ wkid: 4326 })
      );

      // Filtro para la CDMX
      // if(!cdmxExtent.contains(point)) return;
      pointsInside["pc"].push(hotPoint);
      let graphic = new esri.Graphic(point);
      let attributes = {
        fecha: hotPoint.properties.fecha,
        estado: hotPoint.properties.nom_estado,
        municipio: hotPoint.properties.nom_mun,
        vegetación: hotPoint.properties.vegetacion,
        anp: hotPoint.properties.anp,
        pendiente: parseFloat(hotPoint.properties.pendiente).toFixed(2),
        tipo: tipo,
      };

      graphic.setAttributes(attributes);
      let infoTemplateJson = {
        title: "Punto de calor " + tipo,
        content:
          "<b>Fecha: </b> " +
          this.getFormatDate(hotPoint.properties.fecha) +
          "<br>" +
          "<b>Estado: </b> " +
          hotPoint.properties.nom_estado +
          "<br>" +
          "<b>Municipio: </b> " +
          hotPoint.properties.nom_mun +
          "<br>" +
          "<b>Vegetación: </b> " +
          hotPoint.properties.vegetacion +
          "<br>" +
          "<b>Área Natural Afectada: </b> " +
          hotPoint.properties.anp +
          "<br>" +
          "<b>Pendiente(%): </b> " +
          parseFloat(hotPoint.properties.pendiente).toFixed(2) +
          "<br>" +
          "<b>Tipo: </b> " +
          tipo +
          "<br>",
      };

      graphic.setInfoTemplate(new esri.InfoTemplate(infoTemplateJson));
      features.push(graphic);
    });

    let objLayer = this.props.mapView.getLayer(layerId);
    if (objLayer) objLayer.applyEdits(features, null, null);

    var rendererField = "tipo";
    if (!this.state.createdRender) {
      this.setState({ createdRender: true }, () => {
        this.createRender(layerId, rendererField);
      });
    }
  };

  //Crea el render de los puntos, establece el png segun el tipo
  createRender = (layerId, rendererField) => {
    const { esri } = this.props;
    var width = 20;
    var height = 20;
    var layer = this.props.mapView.getLayer(layerId);
    var defaultSymbol = new esri.PictureMarkerSymbol(
      `./imgs/CONABIO/noValue.png`,
      width,
      height
    );
    var diurnoSymbol = new esri.PictureMarkerSymbol(
      `./imgs/CONABIO/fuego_ambar.png`,
      width,
      height
    );
    var noctunoSymbol = new esri.PictureMarkerSymbol(
      `./imgs/CONABIO/fuego_naranja.png`,
      width,
      height
    );

    var renderer = new esri.UniqueValueRenderer(defaultSymbol, rendererField);

    renderer.addValue("Diurno", diurnoSymbol);
    renderer.addValue("Nocturno", noctunoSymbol);

    layer.setRenderer(renderer);
    layer.redraw();
    layer.show();
  };

  //Maneja los eventos de cambio de estado del los controles checkbox
  handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      if (name === "hotPointsD") {
        let layer = this.props.mapView.getLayer(layerNames.Diurnos);
        layer.setVisibility(checked);
        if (checked) {
          this.getPuntos("D");
        } else {
          this.setState({
            loadingDPoints: false,
            loadedDPoints: false,
            hotPointsDData: [],
          });
        }
      } else if (name === "hotPointsN") {
        let layer = this.props.mapView.getLayer(layerNames.Nocturnos);
        layer.setVisibility(checked);
        if (checked) {
          this.getPuntos("N");
        } else {
          this.setState({
            loadingNPoints: false,
            loadedNPoints: false,
            hotPointsNData: [],
          });
        }
      }
    });
  };

  //Ejecuta un acercamiento al mapa
  zoomIn = (p) => {
    var point = new this.props.esri.Point(p.coordinates[1], p.coordinates[0]);
    this.props.mapView.centerAndZoom(point, 14);
  };

  //Agrega ceros al inicio de la cadena
  padStart = (d) => {
    if (d != null) return d.toString().padStart(2, "0");
    else return "";
  };

  //Obtiene el formato de fecha
  getFormatDate = (date) => {
    let d = new Date(date);

    if (d !== "-") {
      return (
        this.padStart(d.getUTCDate()) +
        "-" +
        this.padStart(d.getUTCMonth() + 1) +
        "-" +
        d.getUTCFullYear() +
        " " +
        this.padStart(d.getUTCHours()) +
        ":" +
        this.padStart(d.getUTCMinutes()) +
        ":" +
        this.padStart(d.getUTCSeconds())
      );
    } else return d;
  };

  //Renderea los puntos de calor diurnos en el panel
  renderDPoints() {
    let data = this.state.hotPointsDData;
    let loaded = this.state.loadedDPoints;
    let loading = this.state.loadingDPoints;

    let totalRegs = data?.features?.length ?? 0;
    let rowsPerPage = this.state.rowsPerPageD;
    let page = this.state.pageD;

    let from = page * rowsPerPage;
    let to = page * rowsPerPage + rowsPerPage;
    let currentRows = [];
    if (data?.features) currentRows = data?.features?.slice(from, to);
    let i = 0;
    return (
      <Box mt={1} mb={4}>
        {loaded ? (
          <Typography variant="overline">
            Total puntos:{" " + totalRegs}
          </Typography>
        ) : (
          loading && (
            <Typography variant="overline">Cargando puntos...</Typography>
          )
        )}

        {currentRows.map((p) => {
          return (
            <Box p={1} mb={2} key={i++} component={Paper}>
              <Box>
                <Button onClick={() => this.zoomIn(p.geometry)}>
                  <Typography
                    variant="overline"
                    style={{ fontWeight: "bolder" }}
                  >
                    Fecha: {this.getFormatDate(p.properties.fecha)}
                  </Typography>
                </Button>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Estado:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.nom_estado}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Municipio:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.nom_mun}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Vegetación:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.vegetacion}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Área Natural Afectada:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.anp}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Pendiente(%):{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {Math.round(
                    (parseFloat(p.properties.pendiente) + Number.EPSILON) * 100
                  ) / 100}
                </Typography>
              </Box>
            </Box>
          );
        })}
        {data?.features?.length > 0 && (
          <Table size="small">
            <TableFooter>
              <TableRow>
                <TablePagination
                  size="small"
                  labelRowsPerPage="Filas por pág:"
                  rowsPerPageOptions={[10, 20]}
                  //component="div"
                  count={data?.features?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={(e, newPage) => {
                    this.setState({ pageD: newPage });
                  }}
                  onChangeRowsPerPage={(e) => {
                    this.setState({
                      rowsPerPageD: parseInt(e.target.value, 10),
                    });
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        )}
      </Box>
    );
  }

  //Renderea los puntos de calor nocturnos en el panel
  renderNPoints() {
    let data = this.state.hotPointsNData;
    let loaded = this.state.loadedNPoints;
    let loading = this.state.loadingNPoints;

    let totalRegs = data?.features?.length ?? 0;
    let rowsPerPage = this.state.rowsPerPageN;
    let page = this.state.pageN;

    let from = page * rowsPerPage;
    let to = page * rowsPerPage + rowsPerPage;
    let currentRows = [];
    if (data?.features) currentRows = data?.features?.slice(from, to);
    let i = 0;
    return (
      <Box mt={1} mb={4}>
        {loaded ? (
          <Typography variant="overline">
            Total puntos:{" " + totalRegs}
          </Typography>
        ) : (
          loading && (
            <Typography variant="overline">Cargando puntos...</Typography>
          )
        )}

        {currentRows.map((p) => {
          return (
            <Box p={1} mb={2} key={i++} component={Paper}>
              <Box>
                <Button onClick={() => this.zoomIn(p.geometry)}>
                  <Typography
                    variant="overline"
                    style={{ fontWeight: "bolder" }}
                  >
                    Fecha: {this.getFormatDate(p.properties.fecha)}
                  </Typography>
                </Button>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Estado:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.nom_estado}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Municipio:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.nom_mun}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Vegetación:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.vegetacion}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Área Natural Afectada:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {p.properties.anp}
                </Typography>
              </Box>
              <Box ml={2}>
                <Typography display="inline" variant="caption" color="primary">
                  Pendiente(%):{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {Math.round(
                    (parseFloat(p.properties.pendiente) + Number.EPSILON) * 100
                  ) / 100}
                </Typography>
              </Box>
            </Box>
          );
        })}
        {data?.features?.length > 0 && (
          <Table size="small">
            <TableFooter>
              <TableRow>
                <TablePagination
                  size="small"
                  labelRowsPerPage="Filas por pág:"
                  rowsPerPageOptions={[10, 20]}
                  //component="div"
                  count={data?.features?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={(e, newPage) => {
                    this.setState({ pageN: newPage });
                  }}
                  onChangeRowsPerPage={(e) => {
                    this.setState({
                      rowsPerPageN: parseInt(e.target.value, 10),
                    });
                  }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        )}
      </Box>
    );
  }

  //Render del componente inicial
  render() {
    const { hotPointsD, hotPointsN, tabIndex } = this.state;
    return (
      <Box style={{ width: "100%" }}>
        <Box align="center">
          <a
            href="http://incendios.conabio.gob.mx/"
            color="primary"
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="caption">(CONABIO)</Typography>
          </a>
        </Box>
        <Box p={2}>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={hotPointsD}
                  onChange={this.handleChangeCheck}
                  name="hotPointsD"
                  color="primary"
                />
              }
              label={<Typography variant="caption">Diurnos</Typography>}
            />
          </FormControl>

          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={hotPointsN}
                  onChange={this.handleChangeCheck}
                  name="hotPointsN"
                  color="primary"
                />
              }
              label={<Typography variant="caption">Nocturnos</Typography>}
            />
          </FormControl>
        </Box>

        <Box>
          <AppBar position="static" style={{ width: "100%" }}>
            <Tabs
              name="tabIndex"
              value={tabIndex}
              onChange={(e, n) => {
                this.setState({ tabIndex: n });
              }}
              aria-label="simple tabs results"
            >
              <Tab label="Diurnos" {...a11yProps(0)} />
              <Tab label="Nocturnos" {...a11yProps(1)} />
            </Tabs>
          </AppBar>

          <TabPanel value={tabIndex} index={0} component={Box}>
            <Box>{hotPointsD && this.renderDPoints()}</Box>
          </TabPanel>
          <TabPanel value={tabIndex} index={1} component={Box}>
            <Box>{hotPointsN && this.renderNPoints()}</Box>
          </TabPanel>
        </Box>
      </Box>
    );
  }
}

export default withSnackbar(HotSpots);
